import httpClient from './httpClient';
const prefix = 'withholding'

export default {
    async getAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/getAll`)
    
        return data
      }
}